<td>{{courier.username}}</td>
<td>{{courier.createdDate | date:'d.M.yyyy H:mm'}}</td>
<td>{{courier.phone | phone}}</td>
<td>{{courier.email}}</td>
<td class="buttons">
    <button (click)='onActivateClick()' type="button" class="btn btn--primary">
            Aktivovat účet
    </button>
</td>
